import {
  integer,
  round1,
  formatPlayers,
  ratioToPercent,
} from '../../lib/format';

const FORMATS = {
  none: value => `${value}`,
  plus_minus: value => (value > 0 ? `+${round1(value)}` : `${round1(value)}`),
  possessions: value => `${integer(value)} possessions`,
  points: value => `${round1(value)} points`,
  percent: ratioToPercent,
};

/**
 * Format the lineup summary response
 * @see cypress/fixturs/lineup-summary.json
 */
export function responseToSummary(response, pathTo) {
  const getSummary = item => {
    const summary = { id: item.id, name: item.name };
    if (!response) return summary;

    const type = FORMATS[item.format] || FORMATS.none;
    const data = response[item.id];
    const child = { id: item.id };

    if (data) {
      child.title = type(data.value);
      child.description = data.lineup ? formatPlayers(data.lineup.players) : '';
      child.url = pathTo('lineup-explorer', data.lineup.id);
    } else {
      child.title = 'N/A';
    }

    summary.items = [child];
    return summary;
  };

  return GROUPS.map(({ title, items }) => ({
    title,
    items: items.map(getSummary),
  }));
}

/**
 * TOTALS: Total Possessions Played, Total Plus Minus, Total Points Scored, Total Points Allowed
 * RATES: Plus Minus Per Pos, Points Scored Per Pos, Points Allowed Per Pos
 * FOUR FACTORS: Effective Field Goal %, Offensive Rebound Rate, Free Throw Rate, Turnover Percentage
 * SCORING EFFICIENCY:Field Goal %, Three Point Field Goal %, Two Point Field Goal %, Free Throw %, Three Point Field Goal Attempt Rate, Points Scored Per Shot, True Shooting %
 */
export const GROUPS = [
  {
    title: 'Totals (min 10 possessions played)',
    items: [
      {
        id: 'possessions',
        name: 'Total Possessions Played',
        format: 'possessions',
      },
      {
        id: 'plus_minus',
        name: 'Total Plus Minus',
        format: 'points',
      },
      {
        id: 'pts',
        name: 'Points',
        format: 'points',
      },
    ],
  },
  {
    title: 'Rates (min 10 possessions played)',
    items: [
      {
        id: 'plus_minus_per_possession',
        name: 'Plus Minus Per Possession',
        format: 'plus_minus',
      },
      {
        id: 'points_per_possession',
        name: 'Points Scored Per Possession',
        format: 'points',
      },
      {
        id: 'opp_points_per_possession',
        name: 'Points Allowed Per Possession',
        format: 'points',
      },
    ],
  },
  {
    title: 'Four Factors (min 10 possessions played)',
    items: [
      {
        id: 'efg',
        name: 'Effective Field Goal %',
        format: 'percent',
      },
      {
        id: 'orr',
        name: 'Offensive Rebound Rate',
        format: 'percent',
      },
      {
        id: 'ftr',
        name: 'Free Throw Rate',
        format: 'percent',
      },
      {
        id: 'tov',
        name: 'Turnover Percentage',
        format: 'percent',
      },
    ],
  },
  {
    title: 'Scoring Efficiency (min 10 possessions played)',
    items: [
      {
        id: 'possessions_per_game',
        name: 'Possessions Played Per Game',
        format: 'possessions',
      },
      {
        id: 'points_per_possession',
        name: 'Points Scored Per Possession',
        format: 'points',
      },
      {
        id: 'fg_perc',
        name: 'Field Goal %',
        format: 'percent',
      },
      {
        id: 'fg3_perc',
        name: 'Three Point Field Goal %',
        format: 'percent',
      },
      {
        id: 'fg2_perc',
        name: 'Two Point Field Goal %',
        format: 'percent',
      },
      {
        id: 'ft_perc',
        name: 'Free Throw %',
        format: 'percent',
      },
      {
        id: 'fg3_par',
        name: 'Three Point Field Goal Attempt Rate',
        format: 'percent',
      },
      {
        id: 'pps',
        name: 'Points Scored Per Shot',
        format: 'points',
      },
      {
        id: 'true_shooting',
        name: 'True Shooting %',
        format: 'percent',
      },
    ],
  },
];
